/**
 * Always takes a given value and returns a function that will return that value when invoked.
 *
 * @example
 * import always from '@carvana/futilities/always';
 * const fn = always('blue')
 * fn()
 * // () => 'blue'
 *
 */
function always<T>(val: T): () => T {
  return () => val;
}

export default always;
